<template>
    <div class="short-video-list">

        <short-video-list-skeleton v-if="loading" style="margin-bottom: 100vh"></short-video-list-skeleton>

        <van-row class="short-video-list-section">
            <div class="short-video-list-box" v-for="(item,index) in list" :key="item.id" @click="$router.push({name:'live-column',params:{id:item.id}})">
                <div class="short-video-list-box-img">
                    <van-image
                        fit="cover"
                        :src="item.cover_img"
                        style="width: 100%;height: 100%;border-radius: 6px;"
                    />
                    <div class="short-video-list-box-play-count">
                        <img src="/static/img/icon_live_watch.svg" alt="">
                        {{item.view_count}}
                    </div>
                </div>
                <div class="short-video-list-box-title">{{item.title}}</div>
                <div class="short-video-list-box-desc">{{item.live_desc}}</div>
                <div class="short-video-list-box-author">已开展{{item.current_count}}期</div>
            </div>
            <van-empty description="已到底部" v-if="list.length == 0" />
        </van-row>
    </div>
</template>
<script>
    import Interface from "@/util/interface"
    import shortVideoListSkeleton from "@/skeleton/shortVideoListSkeleton"
    export default {
        name: 'live-column-list',
        components :{
            'short-video-list-skeleton' : shortVideoListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id: 0,
                category_child_id: 0,
                banners: [],
                categories: [],
                categories_child: [],
                recommend: [],
                list:[],
                loading:true
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'column_list') {
                    Interface.getData('get', Interface.live.column.list,{pageSize:999}).then((res) => {
                        this.list = res.data.list
                        setTimeout(()=>{
                            this.loading = false
                        },500)
                    })
                }
            },
        },
        created() {
            this.fetch('column_list')
            Interface.getShareInfo(this,"","","")
        },
    }
</script>
<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/live/column_list/index.vue